import { useContext, useEffect, useMemo, useState } from "react";
import { useLoader } from "@react-three/fiber";
import { useGLTF, MeshRefractionMaterial } from "@react-three/drei";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import stateContext from "../../Context/StateContext";

export function AddDotDiamond() {
    const globalState = useContext(stateContext);

    const { nodes } = useGLTF(
        `${process.env.PUBLIC_URL}/assets/glbs/dot_diamond.glb`
    );
    const diamondGeometry = nodes.rounddiamond.geometry;
    const supportGeometry = nodes.Cylinder.geometry;

    const texture = useLoader(
        RGBELoader,
        `${process.env.PUBLIC_URL}/assets/textures/hdri/ROOM-F - 1.1.hdr`
    );
    const zirconTexture = useLoader(
        RGBELoader,
        `${process.env.PUBLIC_URL}/assets/textures/hdri/studio.hdr`
    );

    const diamondEntries = useMemo(
        () =>
            Array.isArray(globalState.diamondPosData)
                ? globalState.diamondPosData
                : [],
        [globalState.diamondPosData]
    );

    function handlePointerUp(e) {
        e.stopPropagation();
        if (globalState.controlsRef.current) {
            globalState.controlsRef.current.enabled = true;
        }
    }

    useEffect(() => {
        globalState.setUpdateDiamondPos(false);
        globalState.setDiamondPosData([]);
        globalState.setDiamondPosIndex(0);
    }, [
        globalState.text,
        globalState.fontNo,
        globalState.rawPlateSize,
        globalState.selectedFontLanguage,
    ]);

    useEffect(() => {
        function onUp() {
            const ctl = globalState.controlsRef.current;
            if (ctl && !ctl.enabled) ctl.enabled = true;
        }
        window.addEventListener("pointerup", onUp);
        return () => window.removeEventListener("pointerup", onUp);
    }, [globalState.controlsRef]);

    if (!diamondGeometry || !supportGeometry) {
        return null;
    }

    return (
        <>
            {diamondEntries.length > 0 &&
                diamondEntries.map((entry, index) => {
                    const { pos, size } = entry;
                    // const numericSize = parseFloat(size);
                    let color =
                        globalState.activeTabIndex !== 5
                            ? "white"
                            : globalState.updatingDiamondIndex === index
                            ? "blue"
                            : globalState.hoveredDiamondIndex === index
                            ? "red"
                            : "white";

                    return (
                        <group
                            key={index}
                            position={pos}
                            onPointerUp={(e) => handlePointerUp(e)}
                            scale={[
                                globalState.activeDiamondSize / 2,
                                globalState.activeDiamondSize / 2,
                                globalState.activeDiamondSize / 2,
                            ]}
                        >
                            <mesh geometry={diamondGeometry}>
                                <MeshRefractionMaterial
                                    envMap={
                                        globalState.diamondType === "Zircon"
                                            ? zirconTexture
                                            : texture
                                    }
                                    bounces={3}
                                    aberrationStrength={0.03}
                                    ior={2.4}
                                    fresnel={1}
                                    fastChroma
                                    toneMapped={false}
                                    color={color}
                                />
                            </mesh>

                            <mesh geometry={supportGeometry}>
                                <primitive
                                    object={globalState.globalMaterial.default}
                                    attach="material"
                                />
                            </mesh>
                        </group>
                    );
                })}

            {globalState.hoveringDiamondData?.pos && (
                <group
                    position={[
                        globalState.hoveringDiamondData.pos.x,
                        globalState.hoveringDiamondData.pos.y,
                        globalState.hoveringDiamondData.pos.z,
                    ]}
                    scale={[
                        globalState.activeDiamondSize / 2,
                        globalState.activeDiamondSize / 2,
                        globalState.activeDiamondSize / 2,
                    ]}
                >
                    <mesh geometry={diamondGeometry}>
                        <MeshRefractionMaterial
                            envMap={
                                globalState.diamondType === "Zircon"
                                    ? zirconTexture
                                    : texture
                            }
                            bounces={3}
                            aberrationStrength={0.03}
                            ior={2.4}
                            fresnel={1}
                            fastChroma
                            toneMapped={false}
                            color="white"
                        />
                    </mesh>

                    <mesh geometry={supportGeometry}>
                        <primitive
                            object={globalState.globalMaterial.default}
                            attach="material"
                        />
                    </mesh>
                </group>
            )}
        </>
    );
}
